<mat-icon [class]="class()">open_in_new</mat-icon>
